<template>
    <div class="no-data-container">
        <div class="no-data">
            <div>
                <mdicon :name="icon" size="64" />
                <div>
                    <slot name="info"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'no-data',
    props: {
        icon: {
            type: String,
            default: 'mdi-alert-outline'
        },
        fill_height: {
            type: Boolean,
            default: true
        }
    }
}
</script>
